<template>
  <ListPanel mode="processed" :fetch-list="fetchDoneList" />
</template>

<script>
import ListPanel from "./components/list-panel.vue";
import { fetchDoneList } from "@/api/oa/workOrder";

export default {
  name: "workOrderProcessed",
  components: { ListPanel },
  data() {
    return {
      fetchDoneList,
    };
  },
};
</script>
